import { COLORS, marginSm, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 30rem;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: left;
  color: ${COLORS.BLACK};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${paddingMd};
  width: 100%;
  max-height: 500rem;
  overflow-y: auto;
`;

export const RatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15rem;
  width: 100%;
`;

export const RateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15rem;
  width: 100%;
  padding-right: 5rem;

  ${respondTo.smallTablet`
    flex-wrap: wrap;
    align-items: center;
    gap: 10rem;
    border-bottom: 1px solid ${COLORS.BORDER}
  `}
`;

export const CurrencySelectWrapper = styled.div`
  flex: 1;
  min-width: 150rem;
`;

export const RateInputWrapper = styled.div`
  width: 120rem;

  ${respondTo.smallTablet`
    width: 92%;
    margin-bottom: 10rem;
  `}

  ${respondTo.bigPhone`
    width: 85%;
  `}
`;

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.BLACK};
  font-size: 18rem;
`;

export const DeleteButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${respondTo.smallTablet`
    margin-bottom: 10rem;
    margin-left: auto;
  `}
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 15rem;

  ${respondTo.smallPhone`
    justify-content: center;
  `}
`;

export const ApplyWrapper = styled.div`
  display: flex;
  padding-top: 32rem;
  align-items: center;
  justify-content: center;
  gap: 30rem;

  ${respondTo.smallPhone`
    flex-direction: column;
    gap: 10rem;
  `}
`;

export const Label = styled.div`
  padding-top: ${marginSm};
  color: ${COLORS.BLACK};
  font-weight: 500;
  margin-bottom: 5rem;
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20rem;
  color: ${COLORS.GRAY_300};
  text-align: center;
`;
